import { BigNumber, MLString } from '../types.js';
export class PrimitiveParser {
    constructor(primitiveValidator) {
        this.primitiveValidator = primitiveValidator;
    }
    parseString(v) {
        if (this.primitiveValidator.validString(v)) {
            return v;
        }
    }
    parseMlString(v) {
        if (this.primitiveValidator.validMlString(v)) {
            return new MLString(v);
        }
    }
    parseNumber(v) {
        if (this.primitiveValidator.validNumber(v)) {
            return v;
        }
    }
    parseBigNumber(v) {
        if (this.primitiveValidator.validBigNumber(v)) {
            return new BigNumber(v);
        }
    }
    parseBoolean(v) {
        if (this.primitiveValidator.validBoolean(v)) {
            return v;
        }
    }
    parsePrimitive(typeRef, v) {
        switch (typeRef) {
            case 'string': {
                return this.parseString(v);
            }
            case 'mlstring': {
                return this.parseMlString(v);
            }
            case 'number': {
                return this.parseNumber(v);
            }
            case 'bignumber': {
                return this.parseBigNumber(v);
            }
            case 'boolean': {
                return this.parseBoolean(v);
            }
            default: {
                throw new Error('Invalid type');
            }
        }
    }
}
//# sourceMappingURL=PrimitiveParser.js.map